import wxApi from '@/api/wx'
import baseApi from '@/api/base'
import CryptoJS from 'crypto-js'
import Vue from 'vue'

const IMAGE_SERVER = process.env.VUE_APP_FILE_SERVER
const EXTRA_SITE = process.env.VUE_APP_EXTRA_SITE
// const FILE_LIMI_SIZE = 5 // 5MB

const WX_APP_ID = process.env.VUE_APP_WX_APP_ID
const WX_AUTH_URL_BASE = 'https://open.weixin.qq.com/connect/oauth2/authorize'

const commonUtils = {
  getWxAppId () {
    return WX_APP_ID
  },
  isWxEnv () {
    var uaInfo = navigator.userAgent.toLowerCase()
    var isWeixin = uaInfo.indexOf('micromessenger') !== -1
    return isWeixin
  },
  getWxAuthUrl (url, scope, state) {
    if (!url) {
      return ''
    }
    const authScope = scope === 'userInfo' ? 'snsapi_userinfo' : 'snsapi_base'
    if (!state) {
      state = ''
    }
    return WX_AUTH_URL_BASE + '?appid=' + WX_APP_ID + '&redirect_uri=' + encodeURIComponent(url) +
      '&response_type=code&scope=' + authScope + '&state=' + state + '#wechat_redirect'
  },
  getWxUserInfo () {
    const wxUserInfo = JSON.parse(sessionStorage.getItem('wxUserInfo')) || null
    return wxUserInfo
  },
  getCurrentUrl () {
    let curUrl = document.URL
    if (curUrl && curUrl.indexOf('#') >= 0) {
      curUrl = curUrl.substring(0, curUrl.indexOf('#'))
    }
    return curUrl
  },
  getImageUrl (imageUri, defaultUrl) {
    if (!defaultUrl) {
      defaultUrl = require('../assets/images/image-not-found.png')
    }
    console.log('url', imageUri ? IMAGE_SERVER + imageUri : defaultUrl)
    return imageUri ? IMAGE_SERVER + imageUri : defaultUrl
  },
  getExtraSite () {
    return EXTRA_SITE
  },
  parseTime (time, cFormat) {
    if (arguments.length === 0) {
      return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
      date = time
    } else {
      if (('' + time).length === 10) time = parseInt(time) * 1000
      date = new Date(time)
    }
    const formatObj = {
      y: date.getFullYear(),
      m: date.getMonth() + 1,
      d: date.getDate(),
      h: date.getHours(),
      i: date.getMinutes(),
      s: date.getSeconds(),
      a: date.getDay()
    }
    const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
      let value = formatObj[key]
      // Note: getDay() returns 0 on Sunday
      if (key === 'a') {
        return ['日', '一', '二', '三', '四', '五', '六'][value]
      }
      if (result.length > 0 && value < 10) {
        value = '0' + value
      }
      return value || 0
    })
    return timeStr
  },
  convertBase64ToFile (base64Data, fileName) {
    const arr = base64Data.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], fileName, {
      type: mime,
      lastModified: Date.now()
    })
  },
  configWxJsSdk (appMessageShare, timelineShare) {
    // ios系统下，进行wx jssdk验证的url 应为第一次进入页面时的url
    let sdkUrl = null
    const u = navigator.userAgent
    const isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
    if (isIOS) {
      sdkUrl = global.entryUrl
    }
    const curUrl = sdkUrl || this.getCurrentUrl()
    return new Promise((resolve, reject) => {
      wxApi.getJsConfig(curUrl).then(response => {
        if (response.data.resultCode === '0') {
          const wxConfig = response.data.resultData.jsapiConfig
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: wxConfig.appId, // 必填，公众号的唯一标识
            timestamp: wxConfig.timestamp, // 必填，生成签名的时间戳
            nonceStr: wxConfig.nonceStr, // 必填，生成签名的随机串
            signature: wxConfig.signature, // 必填，签名，见附录1
            jsApiList: [
              'scanQRCode',
              'openLocation',
              'getLocation',
              'chooseImage',
              'updateAppMessageShareData',
              'updateTimelineShareData',
              'onMenuShareAppMessage',
              'onMenuShareTimeline'
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
          window.wx.ready(() => {
            console.log('wx ready')
            window.wx.onMenuShareAppMessage(appMessageShare)
            window.wx.onMenuShareTimeline(timelineShare)
            resolve()
          })
          window.wx.error(() => {
            reject(new Error('初始化微信配置失败'))
          })
        } else {
          reject(new Error('获取微信配置失败'))
        }
      }).catch(() => {
        reject(new Error('网络异常'))
      })
    })
  },
  formatToArr (str) {
    let arr = []
    for (let i = 0; i < str.length - 1; i += 2) {
      arr.push(str.substring(i, i + 2))
    }
    return arr
  },
  reportViewTrace (options) {
    let curUrl = document.URL
    let data = {
      traceUrl: curUrl
    }
    if (options === 'activityCode') {
      data.activityCode = 'PartsBeyond'
    } else {
      data = Object.assign(data, options)
    }
    baseApi.reportViewTrace(data)
  },

  // 防连点
  // v-points指令
  preventClick () {
    const pointDoms = [] // 使用这个指令的所有DOM对象
    Vue.directive('points', {
      inserted (el, binding) {
        pointDoms.push(el) // 存储使用这个指令的DOM
        el.addEventListener('click', () => {
          // 禁用所有使用这个指令的DOM结构点击事件
          pointDoms.forEach(pointItem => {
            pointItem.style.pointerEvents = 'none'
          })
          setTimeout(() => {
            // 启动所有使用这个指令的DOM结构点击事件
            pointDoms.forEach(pointItem => {
              pointItem.style.pointerEvents = 'auto'
            })
          }, binding.value || 500)
        })
      }
    })
  },
  compareDate (current, stop) {
    // current, stop:'YYYY-MM-DD'
    return ((new Date(stop.replace(/-/g, "\/"))) > (new Date(current.replace(/-/g, "\/")))) // eslint-disable-line
  }
}

const cryptoUtils = {
  getEncKey () {
    return CryptoJS.enc.Utf8.parse(CryptoJS.MD5('bosch-extra-aes').toString().substr(0, 16))
  },
  getEncIv () {
    return CryptoJS.enc.Utf8.parse(CryptoJS.MD5(this.getEncKey()).toString().substr(0, 16))
  },
  AESEncrypt (srcStr) {
    let encrypted = CryptoJS.AES.encrypt(srcStr, this.getEncKey(), {
      iv: this.getEncIv(),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    })
    return encrypted.toString()
  },
  AESDecrypt (message) {
    let decrypted = CryptoJS.AES.decrypt(message, this.getEncKey(), {
      iv: this.getEncIv(),
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.ZeroPadding
    })
    return decrypted.toString(CryptoJS.enc.Utf8)
  }
}

const mathUtils = {
  floatAdd (arg1, arg2) {
    let r1
    let r2
    let m
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    return (arg1 * m + arg2 * m) / m
  },

  floatSub (arg1, arg2) {
    let r1
    let r2
    let m
    let n
    try {
      r1 = arg1.toString().split('.')[1].length
    } catch (e) {
      r1 = 0
    }
    try {
      r2 = arg2.toString().split('.')[1].length
    } catch (e) {
      r2 = 0
    }
    m = Math.pow(10, Math.max(r1, r2))
    n = (r1 >= r2) ? r1 : r2
    return ((arg1 * m - arg2 * m) / m).toFixed(n)
  },
  floatMul (arg1, arg2) {
    let m = 0
    let s1 = arg1.toString()
    let s2 = arg2.toString()
    try {
      m += s1.split('.')[1].length
    } catch (e) {}
    try {
      m += s2.split('.')[1].length
    } catch (e) {}
    return Number(s1.replace('.', '')) * Number(s2.replace('.', '')) / Math.pow(10, m)
  }
}

export {
  commonUtils,
  cryptoUtils,
  mathUtils
}
